module.exports = __webpack_public_path__ + "static/img/zichan_03.47dca9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zichan_03.png
// module id = Fg66
// module chunks = 1